import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { EventiCard as Original } from 'components/molecules'
import { EventiCardSettings, EventiCardFloatingSettings } from './EventiCardSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { imageDefaultProps } from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'
import { getTextEditor } from '../TextEditor'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import { buttonItemParams } from '../Button'
import {
  layoutDefaultProps,
  layoutItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'

export const defaultProps = {
  ...imageDefaultProps(),
  ...layoutDefaultProps(undefined, false),
  theme: 'light',
  imagePos: 'left',
  icon: '',
}

export const eventiCardParams = (enabled, id, blockProps, children) => ({
  evento: {
    immagine: blockProps.src,
    alt: blockProps.alt,
    ...layoutItemParams(blockProps),
    pk: id,
    icon: blockProps.icon,
    data: getTextEditor(children?.[0], enabled),
    titolo: getTextEditor(children?.[1], enabled),
    sottotitolo: getTextEditor(children?.[2], enabled),
    nomeLocation: getTextEditor(children?.[3], enabled),
    dettagliLocation: getTextEditor(children?.[4], enabled),
    descrizione: getTextEditor(children?.[5], enabled),
    children: getItemChildren(enabled, children?.[6], buttonItemParams),
  },
  theme: blockProps.theme,
  imagePos: blockProps.imagePos,
})

export const dynamicProps = []

export const EventiCard: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-eventi-card ${props.className}`}>
        <Original {...eventiCardParams(enabled, id, blockProps, children)} editMode={enabled} />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

EventiCard.craft = withCraft({
  name: 'EventiCard',
  defaultProps: defaultProps,
  settings: EventiCardSettings,
  floatingSettings: EventiCardFloatingSettings,
})
